<template>
    <div class="grid__container">
        <div class="guide">
            <div class="guide__block guide__block_theme_white">
                <h1>Страницы</h1>
                <div class="guide__content typo-reset">
                    <ol>
                        <li>
                            <router-link to="/guide/">
                                Гайд (вы находитесь здесь)
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/login/">
                                Авторизация/Регистрация (редирект с защищённых страниц)
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/appointments/">
                                * Записать на презентацию
                            </router-link>
                        </li>
                    </ol>
                    <div class="guide__comment">
                        <sup>*</sup> - Страницы, доступные только для зарегистрированных пользователей
                    </div>
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Цвета</h1>
                <p>Наведите на цвет, чтобы узнать его название</p>
                <div class="guide__content">
                    <div class="guide__color"
                         title="white" />
                    <div class="guide__color guide__color-brand-accent"
                         title="brand-accent" />
                    <div class="guide__color guide__color-brand-blue"
                         title="brand-blue" />
                    <div class="guide__color guide__color-brand-blue-lite"
                         title="brand-blue-lite" />
                    <div class="guide__color guide__color-brand-text"
                         title="brand-text" />
                    <div class="guide__color guide__color-brand-title"
                         title="brand-title" />
                    <div class="guide__color guide__color-brand-label"
                         title="brand-label" />
                    <div class="guide__color guide__color-brand-divider"
                         title="brand-divider" />
                    <div class="guide__color guide__color-brand-divider-dark"
                         title="brand-divider-dark" />
                    <div class="guide__color guide__color-brand-border"
                         title="brand-border" />
                    <div class="guide__color guide__color-brand-border-hover"
                         title="brand-border-hover" />
                    <div class="guide__color guide__color-brand-bg-gray"
                         title="brand-bg-gray" />
                    <div class="guide__color guide__color-brand-bg-gray-lite"
                         title="brand-bg-gray-lite" />
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Иконки</h1>
                <p>Наведите на иконку, чтобы узнать название компонента</p>
                <div class="guide__content">
                    <div class="guide__content-row">
                        <div class="guide__content-inner"
                             style="background-color: rgba(0, 0, 0, 0.1);">
                            <div class="guide__icon"
                                 title="IconAlert">
                                <IconAlert />
                            </div>
                            <div class="guide__icon"
                                 title="IconExit">
                                <IconExit />
                            </div>
                            <div class="guide__icon"
                                 title="IconUser">
                                <IconUser />
                            </div>
                            <div class="guide__icon"
                                 title="IconLeftFill">
                                <IconLeftFill />
                            </div>
                            <div class="guide__icon"
                                 title="IconRightFill">
                                <IconRightFill />
                            </div>
                            <div class="guide__icon"
                                 title="IconLeft">
                                <IconLeft />
                            </div>
                            <div class="guide__icon"
                                 title="IconRight">
                                <IconRight />
                            </div>
                            <div class="guide__icon"
                                 title="IconDown">
                                <IconDown />
                            </div>
                            <div class="guide__icon"
                                 title="IconUp">
                                <IconUp />
                            </div>
                            <div class="guide__icon"
                                 title="IconHigher">
                                <IconHigher />
                            </div>
                            <div class="guide__icon"
                                 title="IconLower">
                                <IconLower />
                            </div>
                            <div class="guide__icon"
                                 title="IconArrowDown">
                                <IconArrowDown />
                            </div>
                            <div class="guide__icon"
                                 title="IconPlus">
                                <IconPlus />
                            </div>
                            <div class="guide__icon"
                                 title="IconCheckStatus">
                                <IconCheckStatus />
                            </div>
                            <div class="guide__icon"
                                 title="IconCheckSmall">
                                <IconCheckSmall />
                            </div>
                            <div class="guide__icon"
                                 title="IconInfo">
                                <IconInfo />
                            </div>
                            <div class="guide__icon"
                                 title="IconRepair">
                                <IconRepair />
                            </div>
                            <div class="guide__icon"
                                 title="IconCloseBig">
                                <IconCloseBig />
                            </div>
                            <div class="guide__icon"
                                 title="IconCloseSmall">
                                <IconCloseSmall />
                            </div>
                            <div class="guide__icon"
                                 title="IconEdit">
                                <IconEdit />
                            </div>
                            <div class="guide__icon"
                                 title="IconZoom">
                                <IconZoom />
                            </div>
                            <div class="guide__icon"
                                 title="IconCalendar">
                                <IconCalendar />
                            </div>
                            <div class="guide__icon"
                                 title="IconEyeOff">
                                <IconEyeOff />
                            </div>
                            <div class="guide__icon"
                                 title="IconEye">
                                <IconEye />
                            </div>
                            <div class="guide__icon"
                                 title="IconCheckStatusSmall">
                                <IconCheckStatusSmall />
                            </div>
                            <div class="guide__icon"
                                 title="IconQuestion">
                                <IconQuestion />
                            </div>
                            <div class="guide__icon"
                                 title="IconCreditCard">
                                <IconCreditCard />
                            </div>
                            <div class="guide__icon"
                                 title="IconDocument">
                                <IconDocument />
                            </div>
                            <div class="guide__icon"
                                 title="IconDone">
                                <IconDone />
                            </div>
                            <div class="guide__icon"
                                 title="IconDownload">
                                <IconDownload />
                            </div>
                            <div class="guide__icon"
                                 title="IconLoad">
                                <IconLoad />
                            </div>
                            <div class="guide__icon"
                                 title="IconPaperClip">
                                <IconPaperClip />
                            </div>
                            <div class="guide__icon"
                                 title="IconUnion">
                                <IconUnion />
                            </div>
                            <div class="guide__icon"
                                 title="IconUnionReverse">
                                <IconUnionReverse />
                            </div>
                            <div class="guide__icon"
                                 title="IconUpload">
                                <IconUpload />
                            </div>
                            <div class="guide__icon"
                                 title="IconWarning">
                                <IconWarning />
                            </div>
                            <div class="guide__icon"
                                 title="IconClock">
                                <IconClock />
                            </div>
                            <div class="guide__icon"
                                 title="IconHome">
                                <IconHome />
                            </div>
                            <div class="guide__icon"
                                 title="IconHomeBig">
                                <IconHomeBig />
                            </div>
                            <div class="guide__icon"
                                 title="IconArrowLink">
                                <IconArrowLink />
                            </div>
                            <div class="guide__icon"
                                 title="IconBooking">
                                <IconBooking />
                            </div>
                            <div class="guide__icon"
                                 title="IconBookingEmpty">
                                <IconBookingEmpty />
                            </div>
                            <div class="guide__icon"
                                 title="IconBurger">
                                <IconBurger />
                            </div>
                            <div class="guide__icon"
                                 title="IconFavourites">
                                <IconFavourites />
                            </div>
                            <div class="guide__icon"
                                 title="IconPercent">
                                <IconPercent />
                            </div>
                            <div class="guide__icon"
                                 title="IconPlusBlue">
                                <IconPlusBlue />
                            </div>
                            <div class="guide__icon"
                                 title="IconPurchase">
                                <IconPurchase />
                            </div>
                            <div class="guide__icon"
                                 title="IconAlertOutline">
                                <IconAlertOutline />
                            </div>
                            <div class="guide__icon"
                                 title="IconAlertOutlineWhite">
                                <IconAlertOutlineWhite />
                            </div>
                            <div class="guide__icon"
                                 title="IconCompare">
                                <IconCompare />
                            </div>
                            <div class="guide__icon"
                                 title="IconList">
                                <IconList />
                            </div>
                            <div class="guide__icon"
                                 title="IconLock">
                                <IconLock />
                            </div>
                            <div class="guide__icon"
                                 title="IconDocumentSmall">
                                <IconDocumentSmall />
                            </div>
                            <div class="guide__icon"
                                 title="IconNotification">
                                <IconNotification />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Отступы</h1>
                <div class="guide__content">
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-cyan">
                            <p class="guide__indent-name">
                                cyan (4px/4px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-red">
                            <p class="guide__indent-name">
                                red (8px/8px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-orange">
                            <p class="guide__indent-name">
                                orange (14px/16px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-yellow">
                            <p class="guide__indent-name">
                                yellow (20px/24px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-blue">
                            <p class="guide__indent-name">
                                blue (28px/32px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-green">
                            <p class="guide__indent-name">
                                green (36px/40px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-mint">
                            <p class="guide__indent-name">
                                mint (40px/48px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-gray">
                            <p class="guide__indent-name">
                                gray (48px/56px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-purple">
                            <p class="guide__indent-name">
                                purple (52px/64px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-pink">
                            <p class="guide__indent-name">
                                pink (56px/80px)
                            </p>
                        </div>
                    </div>
                    <div class="guide__content-row">
                        <div class="guide__indent guide__indent-dark-blue">
                            <p class="guide__indent-name">
                                dark-blue (80px/120px)
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Формы</h1>
                <div class="guide__content">
                    <div class="guide__column">
                        <p>Инпут</p>
                        <div class="guide__column-row">
                            <STInput
                                id="guide-input"
                                v-model="value"
                                name="guide-input"
                                label="Input label" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Инпут пароль</p>
                        <div class="guide__column-row">
                            <STInput
                                id="guide-input-password"
                                v-model="password"
                                name="guide-input-password"
                                :type="showPassword ? 'text' : 'password'"
                                :is-password="true"
                                label="Input label"
                                @toogle-password="tooglePassword" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Инпут select</p>
                        <div class="guide__column-row">
                            <STSelect
                                id="guide-select"
                                v-model="select"
                                :options="options"
                                :multiple="false"
                                name="guide-select"
                                label="Input label" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Инпут select (множественный)</p>
                        <div class="guide__column-row">
                            <STSelect
                                id="guide-select"
                                v-model="selectMultiple"
                                :options="options"
                                :multiple="true"
                                name="guide-select"
                                label="Input label" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Инпут select (с кнопкой)</p>
                        <div class="guide__column-row">
                            <STSelect
                                id="guide-select-confirm"
                                v-model="selectConfirm"
                                :options="options"
                                :multiple="true"
                                :is-with-confirmation="true"
                                name="guide-select-confirm"
                                label="Input label" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Выбор даты</p>
                        <div class="guide__column-row">
                            <STDatePickerWrapper
                                id="guide-datepicker"
                                v-model="date"
                                name="guide-datepicker"
                                label="Дата приёмки" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Кнопки</h1>
                <div class="guide__content">
                    <div class="guide__column">
                        <p>Кнопка (не активная)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          :disabled="true" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (иконка слева)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          icon-before="IconRight"
                                          icon-before-modify="icon-stroke icon_color_white" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (иконка справа)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          icon-after="IconRight"
                                          icon-after-modify="icon-stroke icon_color_white" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (маленькая)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          modify="button_size_small" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (другая иконка)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          icon-after="IconRightFill"
                                          icon-after-modify="icon-fill icon_color_white" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (во всю ширину)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          modify="button_full_width" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Белая кнопка</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          icon-after="IconRightFill"
                                          icon-after-modify="icon-fill icon_color_blue"
                                          modify="button_theme_white" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Ссылка</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Link text"
                                          href="/"
                                          modify="button_theme_reset button_font_weight-medium" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Ссылка с иконкой (не активна)</p>
                        <div class="guide__column-row">
                            <STBaseButton text="Button text"
                                          href="/"
                                          icon-before="IconRepair"
                                          icon-before-modify="icon-fill icon_color_blue is-disabled"
                                          modify="button_theme_reset is-disabled" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (без текста)</p>
                        <div class="guide__column-row">
                            <STBaseButton icon-before="IconRight"
                                          icon-before-modify="icon-stroke icon_color_blue"
                                          modify="button_theme_white button_non_text" />
                        </div>
                    </div>
                    <div class="guide__column">
                        <p>Кнопка (без текста)</p>
                        <div class="guide__column-row">
                            <STBaseButton icon-before="IconRight"
                                          icon-before-modify="icon-stroke icon_color_white"
                                          modify="button_size_small button_non_text" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="guide__block guide__block_theme_white">
                <h1>Дополнительно</h1>
                <div class="guide__content">
                    <div class="guide__column">
                        <p>Тултип</p>
                        <div class="guide__column-row">
                            <STTooltip>
                                Вид тултипа меняется на планшетно/мобильном размещении.
                            </STTooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconAlert from '@/components/Icons/Alert';
import IconAlertOutline from '@/components/Icons/AlertOutline';
import IconAlertOutlineWhite from '@/components/Icons/AlertOutlineWhite';
import IconArrowDown from '@/components/Icons/ArrowDown';
import IconArrowLink from '@/components/Icons/ArrowLink';
import IconBooking from '@/components/Icons/Booking';
import IconBookingEmpty from '@/components/Icons/BookingEmpty';
import IconBurger from '@/components/Icons/Burger';
import IconCalendar from '@/components/Icons/Calendar';
import IconCheckSmall from '@/components/Icons/CheckSmall';
import IconCheckStatus from '@/components/Icons/CheckStatus';
import IconCheckStatusSmall from '@/components/Icons/CheckStatusSmall';
import IconClock from '@/components/Icons/Clock';
import IconCloseBig from '@/components/Icons/CloseBig';
import IconCloseSmall from '@/components/Icons/CloseSmall';
import IconCompare from '@/components/Icons/Compare';
import IconCreditCard from '@/components/Icons/CreditCard';
import IconDocument from '@/components/Icons/Document';
import IconDocumentSmall from '@/components/Icons/DocumentSmall';
import IconDone from '@/components/Icons/Done';
import IconDown from '@/components/Icons/Down';
import IconDownload from '@/components/Icons/Download';
import IconEdit from '@/components/Icons/Edit';
import IconExit from '@/components/Icons/Exit';
import IconEye from '@/components/Icons/Eye';
import IconEyeOff from '@/components/Icons/EyeOff';
import IconFavourites from '@/components/Icons/Favourites';
import IconHigher from '@/components/Icons/Higher';
import IconHome from '@/components/Icons/Home';
import IconHomeBig from '@/components/Icons/HomeBig';
import IconInfo from '@/components/Icons/Info';
import IconLeft from '@/components/Icons/Left';
import IconLeftFill from '@/components/Icons/LeftFill';
import IconList from '@/components/Icons/List';
import IconLoad from '@/components/Icons/Load';
import IconLock from '@/components/Icons/Lock';
import IconLower from '@/components/Icons/Lower';
import IconNotification from '@/components/Icons/Notification';
import IconPaperClip from '@/components/Icons/PaperClip';
import IconPercent from '@/components/Icons/Percent';
import IconPlus from '@/components/Icons/Plus';
import IconPlusBlue from '@/components/Icons/PlusBlue';
import IconPurchase from '@/components/Icons/Purchase';
import IconQuestion from '@/components/Icons/Question';
import IconRepair from '@/components/Icons/Repair';
import IconRight from '@/components/Icons/Right';
import IconRightFill from '@/components/Icons/RightFill';
import IconUnion from '@/components/Icons/Union';
import IconUnionReverse from '@/components/Icons/UnionReverse';
import IconUp from '@/components/Icons/Up';
import IconUpload from '@/components/Icons/Upload';
import IconUser from '@/components/Icons/User';
import IconWarning from '@/components/Icons/Warning';
import IconZoom from '@/components/Icons/Zoom';

export default {
    name: 'Guide',

    components: {
        IconWarning,
        IconAlert,
        IconAlertOutline,
        IconAlertOutlineWhite,
        IconArrowDown,
        IconArrowLink,
        IconBooking,
        IconBookingEmpty,
        IconBurger,
        IconCalendar,
        IconCheckSmall,
        IconCheckStatus,
        IconCheckStatusSmall,
        IconClock,
        IconCloseBig,
        IconCloseSmall,
        IconCompare,
        IconCreditCard,
        IconDocument,
        IconDocumentSmall,
        IconDone,
        IconDown,
        IconDownload,
        IconEdit,
        IconExit,
        IconEye,
        IconEyeOff,
        IconFavourites,
        IconHome,
        IconHomeBig,
        IconHigher,
        IconInfo,
        IconLeft,
        IconLeftFill,
        IconList,
        IconLoad,
        IconLock,
        IconLower,
        IconNotification,
        IconPaperClip,
        IconPercent,
        IconPlus,
        IconPlusBlue,
        IconPurchase,
        IconQuestion,
        IconRepair,
        IconRight,
        IconRightFill,
        IconUnion,
        IconUnionReverse,
        IconUp,
        IconUpload,
        IconUser,
        IconZoom,
    },

    data() {
        return {
            value         : '',
            password      : '',
            showPassword  : false,
            date          : '',
            select        : '',
            selectMultiple: [],
            selectConfirm : [],
            options       : [
                { text: 'Выбранный пункт 1', value: 'Выбранный пункт 1' },
                { text: 'Выбранный пункт 2', value: 'Выбранный пункт 2' },
                { text: 'Выбранный пункт 3', value: 'Выбранный пункт 3' }
            ]
        };
    },

    methods: {
        tooglePassword() {
            this.showPassword = !this.showPassword;
        }
    }
};
</script>

<style lang="scss">
    @import "Guide";
</style>
